/*
 * SXF custom requests.
 *
 * The textarea is the control for the "Customization" product option: typing
 * selects the "Custom request" variant (which carries the fee), clearing it
 * selects "Standard". The raw option picker is hidden by CSS in the snippet.
 *
 * Note: the theme REPLACES the <variant-selects> element every time the
 * variant changes, so the picker must be looked up fresh on each use. Caching
 * it leaves a detached node whose radios can be set with no visible effect.
 */
(function () {
  var STANDARD = 'Standard';
  var CUSTOM = 'Custom request';

  function money(cents) {
    var n = cents / 100;
    var s = n % 1 === 0 ? n.toFixed(0) : n.toFixed(2);
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function init(root) {
    if (root.dataset.sxfReady) return;
    root.dataset.sxfReady = '1';

    var sectionId = root.dataset.sectionId;
    var field = root.querySelector('textarea');
    if (!field) return;

    var czIndex = parseInt(root.dataset.czIndex, 10);

    function syncName() {
      if (field.value.trim().length > 0) {
        field.setAttribute('name', field.dataset.propertyName);
      } else {
        field.removeAttribute('name');
      }
    }

    if (isNaN(czIndex) || czIndex < 0) {
      field.addEventListener('input', syncName);
      field.addEventListener('change', syncName);
      syncName();
      return;
    }

    function picker() {
      return document.querySelector('variant-selects[data-section="' + sectionId + '"]');
    }

    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-sxf-variants]').textContent);
    } catch (e) {}

    var idleEl = root.querySelector('[data-sxf-idle]');
    var activeEl = root.querySelector('[data-sxf-active]');
    var feeHintEl = root.querySelector('[data-sxf-fee-hint]');
    var feeActiveEl = root.querySelector('[data-sxf-fee-active]');

    function czControls() {
      var p = picker();
      if (!p) return { radios: [], select: null };
      return {
        radios: Array.prototype.slice.call(
          p.querySelectorAll('input[type="radio"][name^="Customization-"]')
        ),
        select: p.querySelector('select[name="options[Customization]"]'),
      };
    }

    function selectedOptions() {
      var p = picker();
      var out = [];
      if (!p) return out;
      p.querySelectorAll('select[name^="options["]').forEach(function (sel) {
        out.push(sel.value);
      });
      p.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
        out.push(r.value);
      });
      return out;
    }

    function variantFor(czValue) {
      var sel = selectedOptions();
      return variants.filter(function (v) {
        if (v.o[czIndex] !== czValue) return false;
        for (var i = 0; i < v.o.length; i++) {
          if (i === czIndex) continue;
          if (sel.indexOf(v.o[i]) === -1) return false;
        }
        return true;
      })[0];
    }

    function currentFee() {
      var std = variantFor(STANDARD);
      var cus = variantFor(CUSTOM);
      if (!std || !cus) return null;
      return { fee: cus.p - std.p, total: cus.p };
    }

    function paint(isCustom) {
      if (idleEl) idleEl.hidden = isCustom;
      if (activeEl) activeEl.hidden = !isCustom;
      var f = currentFee();
      if (!f) return;
      if (feeHintEl) feeHintEl.textContent = 'Adding a request is ' + money(f.fee) + '.';
      if (feeActiveEl) feeActiveEl.textContent = money(f.fee) + ' added — ' + money(f.total) + ' total.';
    }

    function setCustomization(value) {
      var c = czControls();

      if (c.select) {
        if (c.select.value !== value) {
          c.select.value = value;
          c.select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }

      if (!c.radios.length) return false;

      for (var i = 0; i < c.radios.length; i++) {
        var r = c.radios[i];
        if (r.value === value) {
          if (!r.checked) {
            r.checked = true;
            r.dispatchEvent(new Event('change', { bubbles: true }));
          }
          return true;
        }
      }
      return false;
    }

    var lastState = null;
    function sync() {
      syncName();
      var isCustom = field.value.trim().length > 0;
      if (isCustom !== lastState) {
        lastState = isCustom;
        var target = isCustom ? CUSTOM : STANDARD;
        if (!setCustomization(target)) {
          /* picker mid-rerender: try once more shortly */
          setTimeout(function () { setCustomization(target); }, 400);
        }
      }
      paint(isCustom);
    }

    field.addEventListener('input', sync);
    field.addEventListener('change', sync);

    /* Delegated, because the picker element itself is swapped out on change. */
    document.addEventListener('change', function (e) {
      if (!e.target.closest) return;
      if (!e.target.closest('variant-selects[data-section="' + sectionId + '"]')) return;
      setTimeout(function () { paint(field.value.trim().length > 0); }, 300);
    });

    sync();
  }

  function boot() {
    document.querySelectorAll('[data-sxf-custom-request]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
